<template>
  <div ref="richtext" class="richtext-container" v-html="richtext"></div>
</template>

<script>
import Obs from "ulearning-obs/dist/obs-huawei.js";
import { API_HOST } from "@/config";
import { mapGetters } from "vuex";
export default {
  name: 'RichtextComponent',
  props: ['content'],
  computed: {
    ...mapGetters({ token: "user/token" }),
    richtext () {
      if (this.content === undefined || this.content === null) {
        return ''
      }
      return this.content
    }
  },
  mounted () {
    var self = this;
    if (
      this.$refs.richtext.getElementsByTagName("img") &&
      this.$refs.richtext.getElementsByTagName("img").length > 0
    ) {
      Array.from(this.$refs.richtext.getElementsByTagName("img")).forEach((item) => {
        item.addEventListener("click", () => {
          console.log('item', item)
          self.$viewImage({
            zIndex: 1, // 图片预览的z-index值 一般情况下不需要传
            initialIndex: 0, // 初始化展示图片的序号 默认为0
            imgList: [{url: item.src}], //图片列表 name可选 url必选
            onDownload: self.onDownload
          });
        });
      });
    }
  },
  methods: {
    onDownload(item) {
      let obs = new Obs({
        uptokenHost: API_HOST,
        authorization: this.token,
      })
      obs.download(item.url)
    },
    initMathJax() {
      this.$nextTick(() => {
        try {
          MathJax.Hub.Queue(["Typeset", MathJax.Hub, ""]);
          MathJax.Hub.Config({messageStyle: 'none',tex2jax: {preview: 'none'},
          "HTML-CSS": {
              showMathMenu: false
            }
          });
        } catch (error) {
          console.log(error)
        }
      })
    }
  },
  watch: {
    content: {
      handler () {
        this.initMathJax()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.richtext-container{
  line-height: 1.5;
  font-size: 16px;
  word-break: break-all;
  display: inline-block;
  // overflow: hidden;
  ::v-deep{
    img {
      max-width: 100%;
    }
    p {
      margin: 0;
    }
    svg {
      max-width: 100%;
    }
    ul {
      list-style: disc;
      margin: 0;
      padding: 0;
      li {
        list-style-position: inside;
      }
    }
    ol {
      list-style: decimal;
      margin: 0;
      padding: 0;
      li {
        list-style-position: inside;
      }
    }
  }
}
</style>